import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { Layout, Row, Col } from 'antd';
// import backspace from './backspace';
import './App.css';

import Login from './components/login/index';
import Sider from './components/sider/index';
import Header from './components/header/index';

//数据管理
import Data from './components/data/src/App';

const { Content } = Layout;

function componentFormat(component) {

    return <div>
        <Row style={{

            width: '100%',
            height: '100vh',
            overflow: 'hidden',
            WebkitTouchCallout: 'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',

        }}>
            <Col span={4}><Sider /></Col>
            <Col span={20}>
                <Layout>
                    <Col><Header /></Col>
                    <Content style={{
                        background: '#fff',
                        height: 'calc( 100vh - 120px )'
                    }}>
                        {component}
                    </Content>
                </Layout>
                <p style={{
                    position: 'relative',
                    height: '50px',
                    textAlign: 'right',
                    lineHeight: '50px',
                    fontSize: '16px',
                    borderTop: '1px solid #ccc',
                    color: '#000',
                    padding: '0 50px 0 0',
                    boxShadow: '1px 4px 10px #888888',
                }}>笃实、诚信、创新、共赢！</p>
            </Col>
        </Row>
    </div>;

}

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        //默认加载语言包
        // if (window.location.hash.split('/').length < 3) {
        //     window.location.href = window.location.origin +
        //         window.location.pathname + '#/';
        // }
    }

    //禁止点击后退按钮页面出现返回
    componentWillMount() {
        //处理键盘事件 禁止后退键（Backspace）密码或单行、多行文本框除外
        function forbidBackSpace(e) {
            var ev = e || window.event; //获取event对象
            var obj = ev.target || ev.srcElement; //获取事件源
            var t = obj.type || obj.getAttribute('type'); //获取事件源类型
            //获取作为判断条件的事件类型
            var vReadOnly = obj.readOnly;
            var vDisabled = obj.disabled;
            //处理undefined值情况
            vReadOnly = (vReadOnly === undefined) ? false : vReadOnly;
            vDisabled = (vDisabled === undefined) ? true : vDisabled;
            //当敲Backspace键时，事件源类型为密码或单行、多行文本的，
            //并且readOnly属性为true或disabled属性为true的，则退格键失效
            var flag1 = ev.keyCode === 8 &&
                (t === 'password' || t === 'text' || t === 'textarea') &&
                (vReadOnly === true || vDisabled === true);
            //当敲Backspace键时，事件源类型非密码或单行、多行文本的，则退格键失效
            var flag2 = ev.keyCode === 8 && t !== 'password' && t !== 'text' &&
                t !== 'textarea';
            //判断
            if (flag2 || flag1) return false;
        }

        //禁止后退键 作用于Firefox、Opera
        document.onkeypress = forbidBackSpace;
        //禁止后退键  作用于IE、Chrome
        document.onkeydown = forbidBackSpace;
    }

    render() {
        const DataComponent = (data) => (componentFormat(<Data
            match={data.match} />));
        return (<Router>
            <Switch>
                {/*登录*/}
                <Route exact path={'/'}
                    render={(props) => {
                        return <Login {...props} language={this.language} />
                    }} />
                {/*数据管理*/}
                <Route path={'/data'} component={DataComponent} />
            </Switch>

        </Router>);
    }

}

export default App;
